import produce from 'immer';

// TYPES
import { ReducerActionRotaSP } from 'store/modules/types';
import { Types, ConsultarCpfCinState } from './types';

export const INITIAL_STATE: ConsultarCpfCinState = {
	status: 0,
	data: null,
	dataError: null,
	cpfResponsavel: false,
	cpfRequest: null,
	instanceRequest: undefined,
};

export default function modulos(
	state = INITIAL_STATE,
	action: ReducerActionRotaSP,
): ConsultarCpfCinState {
	return produce(state, draft => {
		switch (action.type) {
			case Types.CONSULTAR_CIN_CPF_REQUEST: {
				draft.status = 100;
				draft.data = INITIAL_STATE.data;
				draft.dataError = INITIAL_STATE.dataError;
				draft.cpfResponsavel = action.variavelBoolean || false;
				draft.instanceRequest = action.instanceRequest;
				draft.cpfRequest = action.payload;
				break;
			}
			case Types.CONSULTAR_CIN_CPF_SUCCESS: {
				draft.status = 200;
				draft.data = action.payload;
				draft.dataError = INITIAL_STATE.dataError;
				break;
			}
			case Types.CONSULTAR_CIN_CPF_FAILURE: {
				draft.status = action.payload.status === 204 ? 204 : 400;
				draft.data = INITIAL_STATE.data;
				draft.dataError = action.payload.data;
				break;
			}
			case Types.CONSULTAR_CIN_CPF_CLEAR: {
				draft.status = INITIAL_STATE.status;
				draft.data = INITIAL_STATE.data;
				draft.dataError = INITIAL_STATE.dataError;
				draft.cpfResponsavel = INITIAL_STATE.cpfResponsavel;
				draft.instanceRequest = INITIAL_STATE.instanceRequest;
				draft.cpfRequest = INITIAL_STATE.cpfRequest;
				break;
			}

			default:
		}
		return draft;
	});
}
